// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see AtmWithdrawalViewMapEvent
 */
export var AtmWithdrawalViewMap = function () { return ({
    name: "Atm Withdrawal ViewMap",
    parameters: {
        cdf_entity: "Atm",
        cdf_action: "Withdrawal",
    }
}); };
/**
 * @see AtmWithdrawalViewVisibleNearbyRetailersEvent
 */
export var AtmWithdrawalViewVisibleNearbyRetailers = function (_a) {
    var visibleRetailers = _a.visibleRetailers;
    return ({
        name: "Atm Withdrawal ViewVisibleNearbyRetailers",
        parameters: {
            cdf_entity: "Atm",
            cdf_action: "Withdrawal",
            visible_retailers: visibleRetailers !== undefined && visibleRetailers !== null ? visibleRetailers.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AtmWithdrawalGrantLocationPermissionEvent
 */
export var AtmWithdrawalGrantLocationPermission = function (_a) {
    var androidLocationAuthorizationStatus = _a.androidLocationAuthorizationStatus, iosLocationAuthorizationStatus = _a.iosLocationAuthorizationStatus, iosPreciseLocationEnabled = _a.iosPreciseLocationEnabled;
    return ({
        name: "Atm Withdrawal GrantLocationPermission",
        parameters: {
            cdf_entity: "Atm",
            cdf_action: "Withdrawal",
            android_location_authorization_status: androidLocationAuthorizationStatus !== undefined && androidLocationAuthorizationStatus !== null ? androidLocationAuthorizationStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ios_location_authorization_status: iosLocationAuthorizationStatus !== undefined && iosLocationAuthorizationStatus !== null ? iosLocationAuthorizationStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ios_precise_location_enabled: iosPreciseLocationEnabled !== undefined && iosPreciseLocationEnabled !== null ? iosPreciseLocationEnabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AtmWithdrawalViewTutorialEvent
 */
export var AtmWithdrawalViewTutorial = function () { return ({
    name: "Atm Withdrawal ViewTutorial",
    parameters: {
        cdf_entity: "Atm",
        cdf_action: "Withdrawal",
    }
}); };
/**
 * @see AtmWithdrawalCloseTutorialEvent
 */
export var AtmWithdrawalCloseTutorial = function () { return ({
    name: "Atm Withdrawal CloseTutorial",
    parameters: {
        cdf_entity: "Atm",
        cdf_action: "Withdrawal",
    }
}); };
/**
 * @see AtmWithdrawalViewExplainerEvent
 */
export var AtmWithdrawalViewExplainer = function () { return ({
    name: "Atm Withdrawal ViewExplainer",
    parameters: {
        cdf_entity: "Atm",
        cdf_action: "Withdrawal",
    }
}); };
/**
 * @see AtmWithdrawalSearchAddressEvent
 */
export var AtmWithdrawalSearchAddress = function () { return ({
    name: "Atm Withdrawal SearchAddress",
    parameters: {
        cdf_entity: "Atm",
        cdf_action: "Withdrawal",
    }
}); };
/**
 * @see AtmWithdrawalSelectAddressEvent
 */
export var AtmWithdrawalSelectAddress = function (_a) {
    var recentAddress = _a.recentAddress;
    return ({
        name: "Atm Withdrawal SelectAddress",
        parameters: {
            cdf_entity: "Atm",
            cdf_action: "Withdrawal",
            recent_address: recentAddress !== undefined && recentAddress !== null ? recentAddress.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AtmWithdrawalViewLocationEvent
 */
export var AtmWithdrawalViewLocation = function (_a) {
    var locationToken = _a.locationToken;
    return ({
        name: "Atm Withdrawal ViewLocation",
        parameters: {
            cdf_entity: "Atm",
            cdf_action: "Withdrawal",
            location_token: locationToken !== undefined && locationToken !== null ? locationToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AtmWithdrawalExplainerClickNeedHelpEvent
 */
export var AtmWithdrawalExplainerClickNeedHelp = function () { return ({
    name: "Atm Withdrawal ExplainerClickNeedHelp",
    parameters: {
        cdf_entity: "Atm",
        cdf_action: "Withdrawal",
    }
}); };
/**
 * @see AtmWithdrawalClickNeedHelpEvent
 */
export var AtmWithdrawalClickNeedHelp = function () { return ({
    name: "Atm Withdrawal ClickNeedHelp",
    parameters: {
        cdf_entity: "Atm",
        cdf_action: "Withdrawal",
    }
}); };
